import DownloadIcon from "assets/icons/DownloadIcon";
import { IconButton } from "@mui/material";
import useDownloadCompetencyMap from "hooks/useDownloadCompetencyMap";
import CircularLoading from "components/CircularLoading";

const DownloadCompetencyMapButton = ({
  competencyMap,
}: {
  competencyMap: { id: string; title: string } | undefined | null;
}) => {
  const { isLoading, getCompetencyMapFile } = useDownloadCompetencyMap();
  const handleDownloadXlsxMap = () => getCompetencyMapFile(competencyMap);
  if (isLoading)
    return (
      <CircularLoading
        size={32}
        sx={{ p: 0, display: "block" }}
      />
    );
  return (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        handleDownloadXlsxMap();
      }}>
      <DownloadIcon />
    </IconButton>
  );
};

export default DownloadCompetencyMapButton;
